import cloneObject from "./cloneObject";
import deepmerge from "./deepmerge";
export default function merge(target, ...sources) {
    for (const source of sources)
        deepmerge(target, cloneObject(source), {
            clone: false,
        });
    return target;
}
